import { useEffect, useRef } from 'react';

/**
 * Correct React video props (autoPlay, playsInline) + play() fallback when
 * autoplay policy blocks attribute-only playback.
 */
export function VideoEmbed({ src, title }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.muted = true;
    const p = el.play();
    if (p !== undefined) {
      p.catch(() => {
        /* Autoplay blocked by browser policy */
      });
    }
  }, [src]);

  return (
    <video
      ref={ref}
      className="mb-4 w-full max-w-full border border-gray-300"
      muted
      loop
      playsInline
      autoPlay
      preload="auto"
      title={title}
    >
      <source src={src} type="video/mp4" />
    </video>
  );
}
